import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BackButton.css'; // Reuse the same CSS for consistency

const HomeButton = () => {
  const navigate = useNavigate();

  return (
    <button className="ozia-back-btn" onClick={() => navigate('/')}>
      <i className="fas fa-home"></i>
      <span>Exit to Home</span>
    </button>
  );
};

export default HomeButton;